// @ts-check
import React from "react";

//
import {
  SNA_ANALYTICS_CATEGORY,
  SNA_ANALYTICS_TYPE,
} from "../../../../../../config/config.sna";

export const selectOpts = Object.entries(SNA_ANALYTICS_TYPE)
  .filter(([key, obj]) => obj.category === SNA_ANALYTICS_CATEGORY.centrality)
  .map(([key, obj]) => ({
    key,
    value: key,
    label: obj.label,
  }));
